<template>
  <div class="container-shader">
    <h2><span style="color:lightcoral;font-weight: bold">F</span>requently <span style="color:lightcoral;font-weight: bold">A</span>sked <span style="color:lightcoral;font-weight: bold">Q</span>uestions
    <button @click.prevent="goBack">Back</button>
    </h2>
      <span>
            Client interface
        </span>
    <button class="question">What is the SaPPo app purpose?</button>
    <div class="panel">
      <br>This is a schedule appointments app, You can make an appointment for all business/office registered on the application.<br>
      <br>
    </div>
      <hr>
    <button class="question">I need an account to use SaPPo app?</button>
    <div class="panel">
        <br>No, what You need is to create a profile that will be stored on your browser and that will be used by SaPPo each time You have to make an appointment.<br><br>
    </div>
      <hr>
    <button class="question">How it works?</button>
    <div class="panel">
      <br>The process it's very simple : Select <span>Business / Office</span> from pop-up list,
      select  available <span >Date & Time </span>,
      push the button <span >Appointment</span> to request date and time<br>
      and check <span>History</span> option from menu to get the status of your appointment - the office will confirm/cancel the appointment
    </div>
      <hr>
    <button class="question">What about privacy?</button>
    <div class="panel">
      <br> A private <span>Access Key</span> will be created by SaPPo when the profile will be saved.<br>
      Each appointment scheduled on the server system will be uniquely identified by this  private <span>Access Key</span>.<br>
      <br>
    </div>
      <hr>
      <button class="question">How can I use History?</button>
      <div class="panel">
          <br>The option History shows all your appointments made by Sappo.You can check the 'online status' of your appointments , filter by office or You can delete the appointments <br><br>
      </div>
      <hr>
  </div>
</template>

<script>
export default {
  name: 'FaQ',
    mounted() {
      this.addQuestionEvents()
    },
    methods: {
      goBack() {
        this.$router.push('/client')
      },
        addQuestionEvents () {
            let acc = document.getElementsByClassName("question");
            for (let i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function() {
                    this.classList.toggle("active");      // ????
                    let panel = this.nextElementSibling; // expand or resume panel
                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px"
                    }
                });
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h3 {
    margin: 40px 0 0;
  }

  .container-shader{
      background-color: black;
      background-size: cover;
      margin: 0 auto;
      height: 100vh;
      width: 100%;
  }
  .question {
    background-color: #ffffff;
    color: #444;
    cursor: pointer;
    padding: 5px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 20px;
    font-family: "Iowan Old Style";
    transition: 0.4s;
  }

  .question:hover {
    color: #dc143c;
    font-size: 22px;
  }

  .active{
    color:  #00008b;
  }
  .question:after {
    content: '\002B';
    color: black;
    font-weight: bold;
    float: right;
    margin-left: 5px;
  }

  .active:after {
    content: "\2212";
  }

  .panel {
    width: 100%;
    padding: 0px;
    background-color: black;
    max-height: 0px;
    overflow: hidden;
    font-size: 15px;
    float: left;
    text-align: left;
    font-family: "Avenir Next";
    transition: max-height 0.2s ease-out;
  }
  span {
    font-size: 20px;
    color: #ff8c00;
  }

  @media screen and (max-width: 600px) {
    button.question {
      font-size: 12px;
    }
    div.panel {
      font-size: 10px;
    }
  }
</style>
